import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestStatus } from '@cpm-pr1618003/ng-initializer-lib';
import { Subscription, take } from 'rxjs';
import { LandingPageFacade } from '../store/facade/landing-page.facade';

@Component({
  selector: 'fm-activating-account',
  standalone: true,
  imports: [AsyncPipe, NgIf],
  templateUrl: './activating-account.component.html',
  styleUrls: ['./activating-account.component.scss'],
})
export class ActivatingAccountComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly landingPageFacade = inject(LandingPageFacade);
  readonly httpRequestStatus = HttpRequestStatus;
  readonly requestStatus$ =
    this.landingPageFacade.reactivateAccountRequestStatus$;
  readonly response$ = this.landingPageFacade.reactivateAccountResponse$;
  readonly errorMessage$ =
    this.landingPageFacade.reactivateAccountErrorMessage$;

  private readonly subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.landingPageFacade.reactivateKey$.pipe(take(1)).subscribe((key) => {
        if (!key) {
          this.landingPageFacade.setReactivateAccountError(
            'Invalid reactivation link.',
          );
          return;
        }
        this.landingPageFacade.reactivateAccount(key);
      }),
    );
  }

  navigateToLandingPage(): void {
    this.router.navigate(['/LandingPage']);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
